import { render, staticRenderFns } from "./aRoomDetailRoomFee.vue?vue&type=template&id=0cc0ead6"
import script from "./aRoomDetailRoomFee.vue?vue&type=script&lang=js"
export * from "./aRoomDetailRoomFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports